import { composeRenderProps } from "react-aria-components";
import { twMerge } from "tailwind-merge";

export type { BrandProviderProps, BrandVariables } from "./BrandProvider";
export { BrandProvider } from "./BrandProvider";
export { ColorModeProvider, useColorMode } from "./ColorModeProvider";

// Re-export formatting utilities from the new formatting module
export * from "./formatting";

// Re-export time formatting utilities
export * from "./timeFormat";

export function focusRing(showDefaultOutline: boolean = false) {
  // Use data-[focus-visible] instead of :focus-visible to work with React Aria's focus management
  const baseClasses = showDefaultOutline
    ? "outline outline-1 outline-border-input data-[focus-visible]:outline-2 data-[focus-visible]:outline-action-default data-[focus-visible]:outline-offset-0 invalid:outline-2 invalid:outline-feedback-error-border group-invalid:outline-2 group-invalid:outline-feedback-error-border forced-colors:focus:outline-[Highlight] forced-colors:focus:outline-2 forced-colors:focus:outline-offset-2"
    : "outline-none data-[focus-visible]:outline data-[focus-visible]:outline-2 data-[focus-visible]:outline-action-default data-[focus-visible]:outline-offset-0 invalid:outline-2 invalid:outline-feedback-error-border group-invalid:outline-2 group-invalid:outline-feedback-error-border forced-colors:focus:outline-[Highlight] forced-colors:focus:outline-2 forced-colors:focus:outline-offset-2";
  return `${baseClasses}`;
}

export function composeTailwindRenderProps<T>(
  className: string | ((v: T) => string) | undefined,
  tw: string
): string | ((v: T) => string) {
  return composeRenderProps(className, (className) => twMerge(tw, className));
}
